<template>
  <div ref="menuDiv" class="rounded-lg shadow-menu" :class="[sizeClass, schemeClass]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';

import { MenuScheme, Size } from './types';

const props = defineProps({
  scheme: {
    type: String as PropType<MenuScheme>,
    default: 'default',
  },
  size: {
    type: String as PropType<Size>,
    default: 'full',
  },
});

const schemeClasses = {
  default: 'bg-white',
  dark: 'bg-grey-700 text-grey-100',
  custom: '',
};

const sizeClasses: Record<Size, string> = {
  '2xs': 'w-32',
  xs: 'w-36',
  sm: 'w-44',
  md: 'w-60',
  lg: 'w-72',
  xl: 'w-80',
  '2xl': 'w-96',
  full: 'min-w-full w-max',
  custom: '',
};

const schemeClass = computed(() => schemeClasses[props.scheme]);
const sizeClass = computed(() => sizeClasses[props.size]);

const menuDiv = ref<HTMLDivElement>();

defineExpose({ menuDiv });
</script>
